import styles from './Career.module.css';
import MobileSearchbar from '@src/components/Base/Header/MobileSearchbar';
import WindowDimension from '@src/components/Base/WindowDimension';
import Header from '@src/components/Base/Header/StandardHeader';
import DefaultHead from '@src/components/Base/Head/DefaultHead';
import Footer from '@src/components/Base/Footer/Footer';
import Meta from '@src/components/Base/Head/Meta';
import Recurit from '@src/components/Career/Recurit';

const Career = () => {
  // Style
  const { width } = WindowDimension();

  return (
    <>
      <DefaultHead />
      <Meta title={`리걸엔진 | 까리용 채용`} description={`까리용은 언제나 채용하고 있습니다`} url={`career`} />
      <Header imgSrc='logo.svg' />
      {/* MobileSearchbar 추가됨  */}
      <MobileSearchbar />
      <div className={styles.careerBody} style={{ marginTop: width > 993 ? '65px' : '0' }}>
        {/* Jumbotron */}
        <section className={styles.sectionJumbotron}>
          <div className={styles.sectionContanier}>
            <h1 className={styles.sectionTitle}>
              까리용은 마음을 읽는 법률 검색
              <br />
              리걸엔진을 만듭니다
            </h1>
            <a href='#recurit'>
              <div className={styles.sectionButton}>진행 중인 채용</div>
            </a>
          </div>
        </section>
        {/* Mission statement */}
        <div className={styles.careerContents}>
          <section className={styles.sectionMission}>
            <div className={styles.sectionRow}>
              <div className={styles.description}>
                까리용은 법률 전문가의 마음을 읽어 법률 검색을 돕는 서비스를 만들자는 목표로 변호사와 엔지니어가 모인
                팀입니다. SCI 논문 3건 등재 공학박사, 소프트웨어 엔지니어, 수천억 원의 소송 가액을 다투던 변호사 등
                다양한 경험을 쌓은 팀원으로 구성되어 있습니다. 이들이 모여 마음을 읽는 법률 검색 솔루션 개발을 위해 NLP
                기초 라이브러리부터, 검색 서비스까지 다양한 머신러닝 제품에 집중하고 있습니다.
              </div>
            </div>
          </section>
          {/* Values */}
          <section className={styles.sectionValues}>
            <h2 className={styles.title}>까리용은 이런 사람들이 모여있습니다</h2>
            <div className={styles.description}>
              <div className={styles.sectionRow}>
                <div className={styles.valueItemNum}>1</div>
                <div className={styles.valueItemContent}>언제나 사용자를 먼저 생각합니다</div>
              </div>
              <div className={styles.sectionRow}>
                <div className={styles.valueItemNum}>2</div>
                <div className={styles.valueItemContent}>빠르게 움직입니다</div>
              </div>
              <div className={styles.sectionRow}>
                <div className={styles.valueItemNum}>3</div>
                <div className={styles.valueItemContent}>항상 배웁니다</div>
              </div>
              <div className={styles.sectionRow}>
                <div className={styles.valueItemNum}>4</div>
                <div className={styles.valueItemContent}>오버 커뮤니케이션 합니다</div>
              </div>
              <div className={styles.sectionRow}>
                <div className={styles.valueItemNum}>5</div>
                <div className={styles.valueItemContent}>이기는 것을 좋아합니다</div>
              </div>
            </div>
          </section>
          {/* Perks */}
          <section className={styles.sectionPerks}>
            <h2 className={styles.title}>까리용 제도</h2>
            <div className={styles.sectionRow}>
              <div className={styles.perkEmoji}>🖥️</div>
              <div className={styles.perksItem}>
                <h3 className={styles.perksItemTitle}>근무 제도</h3>
                <div className={styles.perksItemParagraph}>
                  출퇴근이 자유롭습니다. 우리의 유일한 판단 기준은 성과입니다.
                </div>
              </div>
              <div className={styles.perkEmoji}>✈️</div>
              <div className={styles.perksItem}>
                <h3 className={styles.perksItemTitle}>휴가 제도</h3>
                <div className={styles.perksItemParagraph}>
                  휴가를 제한하지 않습니다. 쉬고 싶을 때 쉬고 일할 때 집중합니다.
                </div>
              </div>
              <div className={styles.perkEmoji}>📕</div>
              <div className={styles.perksItem}>
                <h3 className={styles.perksItemTitle}>교육 지원</h3>
                <div className={styles.perksItemParagraph}>
                  팀원의 성장이 회사의 성장입니다. 강의 수강, 서적 등을 지원합니다.
                </div>
              </div>
            </div>
          </section>
          {/* Hiring */}
          <section id='recurit' className={styles.sectionRecurit}>
            <h2 className={styles.title}>진행 중인 채용</h2>
            <Recurit />
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Career;
